import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface UserNotificationPreferenceDto {
  organizationId: number;
  userId: number;
  phoneNumber: string;
  smsNotificationsEnabled: boolean;
  mediaUploadConsentEnabled: boolean;
  dateCreated: string;
  dateModified?: string;
}

export interface UserNotificationPreferenceUpsertDto {
  organizationId: number;
  phoneNumber: string;
  smsNotificationsEnabled: boolean;
  mediaUploadConsentEnabled: boolean;
}

@Injectable({ providedIn: 'root' })
export class UserNotificationPreferenceService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/user-notification-preferences';

  getMineByOrganization(organizationId: number): Observable<UserNotificationPreferenceDto> {
    return this.http.get<UserNotificationPreferenceDto>(`${this.apiUrl}/organization/${organizationId}`);
  }

  upsertMineByOrganization(organizationId: number, dto: UserNotificationPreferenceUpsertDto): Observable<UserNotificationPreferenceDto> {
    return this.http.put<UserNotificationPreferenceDto>(`${this.apiUrl}/organization/${organizationId}`, dto);
  }
}
